import clsx from 'clsx';
import React, { forwardRef } from 'react'
import Loader from './loader';

type ButtonVariant = "primary" | "outlined"

const BASE = "w-full inline-flex items-center justify-center gap-2.5 text-center px-6 rounded-full text-white cursor-pointer select-none transition-[transform,box-shadow,filter,background-color,border-color] duration-[120ms] ease-out-cubic active:scale-[0.96] disabled:cursor-not-allowed disabled:active:scale-100"

const GetVariant = (variant?: ButtonVariant) => {
    if (variant === "outlined") {
        return clsx(BASE, "h-[54px] bg-ghost border-[1.5px] border-[rgba(63,102,255,0.55)] text-[15px] font-bold animate-breathe hover:bg-none hover:bg-[#16204A] disabled:opacity-50 disabled:animate-none")
    }

    return clsx(BASE, "h-[56px] bg-cta shadow-cta text-buttonLG hover:brightness-110 disabled:bg-cta-disabled disabled:shadow-none disabled:text-white/40 disabled:hover:brightness-100")
}

interface ICustomButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    loading?: boolean;
    disabled?: boolean;
    className?: string
    variant?: ButtonVariant
}

const CustomButton = forwardRef<HTMLButtonElement, ICustomButton>(({ loading, variant, disabled, children, className, ...props }) => {
    return (
        <button disabled={disabled || loading} aria-busy={loading || undefined} {...props} className={clsx(GetVariant(variant), loading && "!bg-cta !cursor-wait !shadow-cta !text-white", className)}>
            {loading ? <Loader /> : children}
        </button>
    )
})

export default CustomButton
